import { format, parseISO } from 'date-fns';
import { Icon } from '@iconify/react';
import "./TurnCard.scss"    //no lo esta usando, me toma los styles de TransferRequestCard.scss por alguna razon
import { es } from 'date-fns/locale';
import { AppointmentsDTO } from "../../interface/interface";

export const TurnCard = ({ record, handleClick }: { record: AppointmentsDTO; handleClick?: any }) => {

  const iconStyle = {
    color: '#263563',
    fontSize: '25px',
    padding: '3px',
    borderRadius: '20%',
  };

  const hasAppointment = record.patientname != null && record.patientname != "";
  const outOfSchedule = hasAppointment && record.outofschedule;
  const grouped = hasAppointment && record.appointmentsgrouped;

  const appointmentdatetime = record.appointmentdatetime.toString();

  const patientname = hasAppointment ? record.patientname : "";
  const businessname = hasAppointment ? record.businessname : "";
  const state = hasAppointment ? record.descriptionappointmentstate : "";

  return (
    <div className={`mb-2`} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', fontFamily: 'Arial, sans-serif', marginBottom: '10px', borderRadius: '2px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)', borderLeft: '1px solid #474747' }}>
      <button disabled={false} style={{ background: 'transparent', border: 'none', width: '100%' }} onClick={() => hasAppointment ? "" : handleClick(record, false)}>
        <div style={{ padding: '8px', backgroundColor: '#fff', textAlign: 'left' }}>
          <div style={{ marginBottom: '8px', paddingLeft: '10px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

              <div style={{ paddingBottom: '8px', display: 'flex' }}>
                <div style={{ color: 'black', padding: '8px', paddingRight: '20px', fontWeight: 500, display: 'flex', flexDirection: 'column', borderRight: '1px solid #999999' }}>
                  <span style={{ fontSize: '20px' }}><strong>{format(parseISO(appointmentdatetime), 'dd/MM', { locale: es })}</strong></span>
                  <span>{record.dayname}</span>
                </div>

                <div style={{ padding: '12px', display: 'flex', flexDirection: 'column' }}>
                  <span style={{ color: 'black' }}><strong>{format(parseISO(appointmentdatetime), 'HH:mm', { locale: es })} hs</strong></span>
                  <span style={{ color: 'black', fontWeight: 500 }}>{hasAppointment ? patientname : "Turno Libre"}</span>
                </div>
              </div>

              <span style={{ height: '100%', color: outOfSchedule ? "#FF5F3D" : (grouped ? "#10B6B4" : ""), backgroundColor: outOfSchedule ? "rgba(255, 95, 61, 0.05)" : (grouped ? "rgba(82, 242, 239, 0.05)" : "transparent"), padding: "2px 6px", borderRadius: "5px" }}> <b>{outOfSchedule ? 'Sobreturno' : (grouped ? 'Grupal' : '')}</b> </span>
            </div>

            {hasAppointment && <span style={{ marginBottom: '8px', borderBottom: '1px solid #999999' }}></span>}
            <span style={{ color: '#999999' }}>{hasAppointment ? (<><span style={{ color: '#999999' }}>Obra Social:</span>{' '}<span style={{ color: 'black' }}><strong>{businessname}</strong></span></>) : ""}</span>
          </div>
          <div style={{ paddingLeft: '10px', display: 'flex', flexDirection: 'column' }}>
            {hasAppointment && <span style={{ borderBottom: '1px solid #999999' }}></span>}
            {hasAppointment && <div style={{ paddingTop: '8px', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#999999' }}>{hasAppointment ? (<><span style={{ color: '#999999' }}>Estado:</span>{' '}<span style={{ color: 'black' }}><strong>{state}</strong></span></>) : ""}</span>
              <div>
                <button style={{ marginRight: '8px', background: 'transparent', color: '#263563', border: '1px solid #263563', borderRadius: '5px', padding: '5px 10px' }} onClick={() => handleClick(record, true)}><Icon icon='bi:chat' style={iconStyle} /></button>
                <button style={{ background: 'transparent', color: '#263563', border: '1px solid #263563', borderRadius: '5px', padding: '5px 10px' }} onClick={() => handleClick(record, false)}><Icon icon='bi:info-circle' style={iconStyle} /></button>
              </div>
            </div>}
          </div>
        </div>
      </button>
    </div>
  );
};